import Split from 'react-split'
import {
  useState, useEffect, useMemo, useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';

import { setVacancies } from '@App/components/Map/map.slice';
import { filterVacancies } from '@App/pages/Filter/filter.utils';

import Nav from '@App/components/Nav/Nav';
import Map from '@App/components/Map/Map';
import Breadcrumbs from '@App/components/Breadcrumbs/Breadcrumbs';
import ActionsMenu from '@App/components/ActionsMenu/ActionsMenu';

import './shared-base.styl';

function SharedBase() {
  const dispatch = useDispatch();
  const { vacancyId } = useParams();

  const allVacancies = useSelector(state => state.map.allVacancies);
  const filter = useSelector(state => state.filter);
  const searchGeometry = useSelector(state => state.map.searchGeometry);

  const [map, setMap] = useState();
  const [hoveredFeature, setHoveredFeature] = useState();
  const [clickedFeature, setClickedFeature] = useState();
  const [searchValue, setSearchValue] = useState('');

  const scrollPositionRef = useRef();
  const startingSizes = useRef(searchGeometry || vacancyId ? [60, 40] : [47.5, 52.25]);

  const filteredVacancies = useMemo(() => filterVacancies(allVacancies, filter), [allVacancies, filter]);

  useEffect(() => {
    if (filteredVacancies) {
      dispatch(setVacancies(filteredVacancies));
    }
  }, [dispatch, filteredVacancies]);

  useEffect(() => {
    if (map && filteredVacancies) {
      map.getSource('vacancies').setData({
        type: 'FeatureCollection',
        features: filteredVacancies.filter(v => (
          v?.properties?.distanceToHomeAddress
        )),
      });
    }
  }, [filteredVacancies, map]);

  return (
    <div className="shared-base">
      <Nav />
      <Split
        className="shared-base__container"
        sizes={startingSizes.current}
        minSize={450}
        gutterSize={0}
        cursor="ew-resize"
      >
        <div className="shared-base__container__left">
          <div className="shared-base__container__left__thumb" />
          <div className="shared-base__container__left__utils-bar">
            <Breadcrumbs />
            <ActionsMenu />
          </div>
          <Outlet
            context={{
              clickedFeature,
              hoveredFeature,
              map,
              scrollPositionRef,
              searchValue,
              setSearchValue,
            }}
          />
        </div>
        <div className={`shared-base__container__right${!map ? ' is-loading' : ''}`} id="map-container">
          <Map
            map={map}
            setMap={setMap}
            setHoveredFeature={setHoveredFeature}
            setClickedFeature={setClickedFeature}
          />
        </div>
      </Split>
    </div>
  )
}

export default SharedBase;
